<template>
  <!--消费记录-->
  <x-recordModule></x-recordModule>
</template>

<script>
import recordModule from '@/components/package/recordModule.vue';
export default {
  components: {
    xRecordModule: recordModule
  },
  name: 'recordModule',
  data () {
    return {};
  },
  mounted () {},
  methods: {}
};
</script>
